import { render, staticRenderFns } from "./jyService.vue?vue&type=template&id=1058a31c&scoped=true&"
import script from "./jyService.vue?vue&type=script&lang=js&"
export * from "./jyService.vue?vue&type=script&lang=js&"
import style0 from "./jyService.vue?vue&type=style&index=0&id=1058a31c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1058a31c",
  null
  
)

export default component.exports